import { Component, OnChanges, OnInit, Input } from '@angular/core';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { Location } from '@angular/common';
import { HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { throwError } from 'rxjs';
import { Title } from '@angular/platform-browser';

import { environment } from '../../environments/environment';
import { IRoughcheck, IReport } from '../roughcheck';
import { MessageService } from '../message.service';
import { RoughcheckService } from '../roughcheck.service';
import { LoggerService } from '../logger.service';

@Component({
  selector: 'app-report',
  templateUrl: './report.component.html',
})
export class ReportComponent {

  @Input() report: IReport = {
    id: '',
    section_id: 0,
    question_id: 0,
    title: '',
    description: '',
    risk_default_id: 0,
    risk_default_title: '',
    risk_default_description: '',
    risk_id: 0,
    risk_title: '',
    risk_description: '',
    reward_default_id: 0,
    reward_default_title: '',
    reward_default_description: '',
    reward_id: 0,
    reward_title: '',
    reward_description: '',
    progress: 0,
    notes: ''
  };

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private service: RoughcheckService,
    private location: Location,
    private message: MessageService,
    private logger: LoggerService,
    private title: Title
  ) { }

}
